<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="740px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form :model="formInline" ref="form" label-width="160px">
        <el-form-item label="是否一次性事项">
          <el-radio-group v-model="formInline.gzSfycxsx">
            <el-radio label="是">是</el-radio>
            <el-radio
              v-if="
                formInline.ghEventTypeId != 'd10c6dde183291179f06113d400f08bb'
              "
              label="否"
              >否</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="formInline.gzSfycxsx == '否'" label="事件每">
          <el-input-number
            v-model="formInline.gzXhzq"
            :min="1"
          ></el-input-number
          ><span style="font-size: 14px;color: #606266;font-weight: 700;"
            >天循环一次</span
          >
        </el-form-item>
        <el-form-item
          :label="formInline.gzSfycxsx == '否' ? '事件开始日期' : '执行日期'"
        >
          <el-date-picker
            v-model="formInline.gzZxrq"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          :label="
            formInline.gzSfycxsx == '否' ? '每天任务执行时间' : '执行时间'
          "
        >
          <div
            style="margin-bottom: 10px;"
            v-for="(item, index) in formInline.gzZxsj"
            :key="index"
          >
            <el-time-picker
              v-model="item.time"
              placeholder="选择时间"
              value-format="HH:mm:ss"
              format="HH:mm:ss"
            >
            </el-time-picker>
            <i
              v-if="
                formInline.gzZxsj.length === 1 ||
                  formInline.gzZxsj.length - 2 === index
              "
              class="el-icon-plus"
              style="cursor: pointer;margin-left: 15px;font-size: 24px;"
              @click="pushFixedTimes"
            ></i>
            <i
              class="el-icon-minus"
              v-if="
                formInline.gzZxsj.length > 1 &&
                  formInline.gzZxsj.length - 1 === index
              "
              style="cursor: pointer;margin-left: 15px;font-size: 24px;"
              @click="minusFixedTimes(index)"
            ></i>
          </div>
        </el-form-item>
        <el-form-item
          v-if="formInline.gzSfycxsx == '否'"
          label="是否跳过节假日"
        >
          <el-radio-group v-model="formInline.gzSftgjjr">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button v-if="pointOtherRulueId" type="primary" @click="useInitRuleFun"
        >恢复初始化</el-button
      >
      <el-button type="primary" @click="editRuleFun">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  editRule,
  detailEvent,
  editOtherRule,
  detailOther,
  useInitRule
} from "@/api/base.js";
import moment from "moment";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    pointOtherRulueId: {
      type: String,
      default: ""
    },
    type: {
      type: Number,
      default: 1
    },
    eventMangerId: {
      type: String,
      default: ""
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
    unionIdList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      title: "事项初始规则管理",
      formInline: {
        gzSfycxsx: "是",
        gzXhzq: null,
        gzZxrq: null,
        gzZxsj: [{ time: "" }],
        gzSftgjjr: "是",
        gzCqsffg: "是",
        gzSfqzsm: "是",
      }
    };
  },
  mounted() {
    if (this.type == 2) {
      this.title = "点位事项任务规则管理";
      if (this.unionIdList.length <= 1) {
        if (this.pointOtherRulueId) this.detailOtherFun();
        else this.detailEventFun();
      }
    } else {
      this.detailEventFun();
    }
  },
  methods: {
    pushFixedTimes() {
      this.formInline.gzZxsj.push({
        time: ""
      });
    },
    minusFixedTimes(index) {
      this.formInline.gzZxsj.splice(index, 1);
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async detailEventFun() {
      const res = await detailEvent({
        id: this.eventMangerId || this.curItem.id
      });
      this.formInline = res.data.data;
      this.formInline.gzSfycxsx = res.data.data.gzSfycxsx || "是";
      let times = this.formInline.gzZxsj && this.formInline.gzZxsj.split(",");
      if (times && times.length) {
        this.formInline.gzZxsj = [];
        times.forEach(item => {
          this.formInline.gzZxsj.push({
            time: item
          });
        });
      } else {
        this.formInline.gzZxsj = [{ time: "" }];
      }
    },
    async detailOtherFun() {
      const res = await detailOther({
        id: this.pointOtherRulueId
      });
      this.formInline = res.data.data;
      this.formInline.gzSfycxsx = res.data.data.gzSfycxsx || "是";
      let times = this.formInline.gzZxsj && this.formInline.gzZxsj.split(",");
      if (times && times.length) {
        this.formInline.gzZxsj = [];
        times.forEach(item => {
          this.formInline.gzZxsj.push({
            time: item
          });
        });
      } else {
        this.formInline.gzZxsj = [{ time: "" }];
      }
    },
    async editRuleFun() {
      let gzZxsj = this.formInline.gzZxsj
        .filter(item => !!item.time)
        .map(item => item.time);
      let params = {
        gzSfycxsx: this.formInline.gzSfycxsx,
        gzXhzq: this.formInline.gzXhzq,
        gzZxrq: moment(this.formInline.gzZxrq).format("YYYY-MM-DD"),
        gzZxsj: gzZxsj.toString(),
        gzSftgjjr: this.formInline.gzSftgjjr,
        gzCqsffg: this.formInline.gzCqsffg,
        gzSfqzsm: this.formInline.gzSfqzsm,
        gzCqtxsc: 0,
        gzCqyz: 0,
        id: this.curItem.id
      };
      let res = null;
      if (this.type == 1) {
        res = await editRule(params);
      } else {
        params.unionIdList = this.unionIdList;
        res = await editOtherRule(params);
      }
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async useInitRuleFun() {
      let params = {
        id: this.pointOtherRulueId
      };
      const res = await useInitRule(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  width: 340px !important;
}

/deep/.el-input-number .el-input {
  width: 180px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/baseInfo/issuesManagement/components/ruleSettingDialog.vue